window.addEventListener('DOMContentLoaded', function(e) {
    let paraScroll = (parallax, compStyles) => {
        let newPos = 50 - (parallax.getBoundingClientRect().top / window.innerHeight * 50);
        if (newPos > 50) {
            //newPos = 50;
        }
        parallax.setAttribute('style', `--tooltip-transform: ${newPos}%;`);
    }

    let parallaxes = document.querySelectorAll('.parallax-parent');
    if (parallaxes) {
        parallaxes.forEach(parallax => {
            let compStyles = window.getComputedStyle(parallax);

            // Do once on page load in case element is already in viewport
            if (parallax.getBoundingClientRect().top <= window.innerHeight && parallax.getBoundingClientRect().bottom > 0) {
                paraScroll(parallax, compStyles);
            }
            
            window.addEventListener('scroll', () => {
                if (parallax.getBoundingClientRect().top <= window.innerHeight && parallax.getBoundingClientRect().bottom > 0) {
                    paraScroll(parallax, compStyles);
                }
            })
        })
    }
})